import React, { useState } from "react";
import ResultDisplay from "./ResultDisplay";
import SearchArcgis from "./Search";
import SingleTypeSelector from "./SingleTypeSelector";
import SuggestionDisplay from "./SuggestionDisplay";
import TabTypeSelector from "./TabTypeSelector";
import PopupDisplay from "./PopupDisplay";
import PopupButton from "./PopupButton";

export default function LookupDisplay(props) {
    const [searchType, setSearchType] = useState(0);
    const [searchedParcel, setSearchedParcel] = useState(null)
    const [suggestions, setSuggestions] = useState({});
    const [requestLoading, setRequestLoading] = useState(false);
    const [searchWidget, setSearchWidget] = useState(null);
    const [results, setResults] = useState([])
    const [address, setAddress] = useState(null)
    const [isPopupOpen, setIsPopupOpen] = useState(true);

    return (
        <div className="w-full flex flex-col fixed bottom-6 top-0">
            <div className="flex flex-col md:flex-row w-full h-full justify-center items-center bg-city-white absolute top-0 right-0 left-0 bottom-6">

                <PopupDisplay isPopupOpen={isPopupOpen} setIsPopupOpen={setIsPopupOpen} title="About">
                    <TabTypeSelector />
                </PopupDisplay>

                <div className="flex w-full flex-col md:h-full md:justify-center md:items-center">
                    <div className="font-bold">
                        <div className="text-xl my-2">
                            Land Value Tax Estimator
                        </div>
                    </div>
                    <SingleTypeSelector
                        selectableType={searchType}
                        setSelectableType={setSearchType}
                        types={props.searchManager.searchTypes} // need list of objects with each object having a "label" value
                        selectorHeader={props.searchManager.searchText.searchHeader}
                    />
                    <SearchArcgis
                        searchManager={props.searchManager}
                        searchType={searchType}
                        setSuggestions={setSuggestions}
                        setRequestLoading={setRequestLoading}
                        setSearchWidget={setSearchWidget}
                        searchWidget={searchWidget}
                        setAddress={setAddress}
                        setResults={setResults}
                    />
                    <PopupButton setIsPopupOpen={setIsPopupOpen} />
                </div>
                <SuggestionDisplay
                    results={results}
                    setAddress={setAddress}
                    searchManager={props.searchManager}
                    setRequestLoading={setRequestLoading}
                    suggestions={suggestions}
                    searchType={searchType}
                    requestLoading={requestLoading}
                    searchWidget={searchWidget}
                    setResults={setResults}
                    setSearchedParcel={setSearchedParcel}
                />
                {results.length > 0 ?
                    <ResultDisplay searchedParcel={searchedParcel} results={results} address={address} setAddress={setAddress} setResults={setResults} />
                    : null}
            </div>
            <div className="bg-city-green-dark text-city-white md:text-left md:pl-2 text-xs md:text-sm py-0.5 h-6 bottom-0 w-full fixed overflow-hidden">
            Created by City of Detroit - Data Strategy and Analytics  
            </div>
        </div>
    )
}